import React from 'react'
import styled from 'styled-components'

const StyledPage = styled.div`
  margin: 0.55rem auto 0;
  /* max-width: 1400px; */
  /* padding: 1.45rem 1.0875rem; */
  display: flex;
  justify-content: center;
  background-color: rgb(246, 247, 248);
  overflow: hidden;
  @media (max-width: 900px) {
    margin: 0.55rem auto 0;
  }
`

const Space = styled.div`
  width: 100%;
`

const Page = ({ children }) => (
  <StyledPage>
    <Space>{children}</Space>
  </StyledPage>
)

export default Page
